import { Location } from '#/graphql/types';
import { Key } from '#/types';

export const updateMutationFields: Key<Location>[] = [
  'name',
  'inUseStatus',
  'level',
  'parentId',
  'lat',
  'lng',
  'notes',
  'address',
  'inUseStatus',
];

export const createMutationFields: Key<Location>[] = [
  'name',
  'inUseStatus',
  'level',
  'parentId',
  'lat',
  'lng',
  'notes',
  'address',
  'tenantId',
];
